import { RangeInput } from 'shared/components/RangeInput';
import { FC, ReactNode } from 'react';
import styles from './DropdownPrice.css';

interface IDropdownPriceProps {
  valueMin: number | null;
  valueMax: number | null;
  priceTypeFilter: ReactNode;

  onChangeMin: (value: number | null) => void;
  onChangeMax: (value: number | null) => void;
}

export const DropdownPrice: FC<IDropdownPriceProps> = ({
  valueMax,
  valueMin,
  priceTypeFilter,
  onChangeMax,
  onChangeMin,
}) => {
  return (
    <div className={styles['dropdown']} data-testid="DropdownPrice">
      <div className={styles['dropdown-filter']}>
        <RangeInput
          min={0}
          max={999999999999}
          joined={false}
          postfix={'\u20bd'}
          valueMin={valueMin}
          valueMax={valueMax}
          onChangeMin={onChangeMin}
          onChangeMax={onChangeMax}
        />
      </div>
      <div className={styles['dropdown-filter']} data-testid="DropdownPriceType">
        {priceTypeFilter}
      </div>
    </div>
  );
};
